/**
 * Error Pages Script
 * Handles navigation updates and fun science facts for error pages
 */

import { checkStudentAuth, checkGuardianAuth } from '../../src/utils/auth-helpers';
import { updateNavWithUser } from '../../src/utils/nav-helpers';

// Fun science facts to display
const scienceFacts = [
  "A single bolt of lightning contains enough energy to toast 100,000 slices of bread!",
  "Your brain uses about 20% of your body's energy, even though it's only 2% of your body weight.",
  "Honey never spoils - archaeologists have found 3,000-year-old honey in Egyptian tombs that's still edible!",
  "The speed of light is so fast that it could circle the Earth 7.5 times in one second.",
  "Octopuses have three hearts and blue blood!",
  "A day on Venus is longer than a year on Venus.",
  "Bananas are berries, but strawberries aren't!",
  "Water can exist in three states at the same time (solid, liquid, and gas).",
  "Your DNA, if uncoiled, would stretch 10 billion miles from Earth to Pluto and back!",
  "There are more stars in the universe than grains of sand on all of Earth's beaches.",
  "A teaspoon of neutron star would weigh about 6 billion tons!",
  "Hot water freezes faster than cold water (Mpemba effect).",
  "The human nose can detect over 1 trillion different scents.",
  "Glass is actually a liquid, it just flows extremely slowly.",
  "Sound travels 4 times faster in water than in air.",
  "The Eiffel Tower can be 15 cm taller during summer due to thermal expansion.",
  "Sharks have been around longer than trees!",
  "A bolt of lightning is 5 times hotter than the surface of the sun.",
  "The average person walks the equivalent of three times around the world in a lifetime.",
  "Your stomach gets a new lining every 3-4 days to prevent it from digesting itself!",
];

/**
 * Initialize error page
 */
(async () => {
  // Update navigation with user info if authenticated
  const student = checkStudentAuth();
  if (student) {
    updateNavWithUser(student);
  } else {
    const guardian = await checkGuardianAuth();
    if (guardian) {
      updateNavWithUser(guardian);
    }
  }

  // Display random science fact
  displayRandomFact();

  // Update timestamp if on 500 page
  updateErrorTimestamp();
})();

/**
 * Display a random science fact
 */
function displayRandomFact() {
  const factElement = document.getElementById('scienceFact');
  if (factElement) {
    const randomFact = scienceFacts[Math.floor(Math.random() * scienceFacts.length)];
    factElement.textContent = randomFact;
  }
}

/**
 * Update error timestamp (500 page only)
 */
function updateErrorTimestamp() {
  const timestampElement = document.getElementById('errorTimestamp');
  if (timestampElement) {
    const now = new Date();
    timestampElement.textContent = now.toLocaleString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      timeZoneName: 'short',
    });
  }
}
